<template>
  <div id="conditions">
    <div id="map-container">
      <div class="adaptive-column-content">
        <payment-methods v-if="!isSmartphone" />
      </div>
      <div class="current-zone-info" v-if="isSmartphone">
        <div class="marker" :style="{ backgroundColor: zones[currentZoneIndex].color }"></div>
        <div class="text">
          <div class="title">Зона доставки {{ currentZoneIndex + 1 }}</div>
          <div class="subtitle">Минимальный заказ {{ zones[currentZoneIndex].minSum }} <rub /></div>
        </div>
      </div>
    </div>
    <payment-methods v-if="isSmartphone" />
  </div>
</template>

<script>
  import { map, forEach } from 'lodash'
  import { deliveryZones } from '/src/store/config.js'
  import PaymentMethods from '/src/blocks/PaymentMethods'

  export default {
    name: 'ConditionsPage',
    data () {
      return {
        map: null,
        zones: deliveryZones,
        polygons: [],
        defaultOpacity: 0.6,
        currentZoneIndex: 0
      }
    },
    components: {
      PaymentMethods
    },
    mounted () {
      window.ymaps.ready(() => {
        let targetRatio = this.isSmartphone ? 3.2 / 3.1 : 1047 / 633
        let mapCont = document.getElementById('map-container')
        let realRatio = mapCont.offsetWidth / mapCont.offsetHeight
        let mapXDelta
        if (this.isSmartphone) {
          mapXDelta = -0.1
        } else if (realRatio < targetRatio) {
          mapXDelta = 0
        } else {
          mapXDelta = (realRatio - targetRatio) * mapCont.offsetHeight * 0.00035
        }

        this.map = new window.ymaps.Map('map-container', {
          center: [59.951550, 30.411500 + mapXDelta],
          zoom: this.isSmartphone ? 10 : 11,
          controls: []
        })
        window.polygons = []
        forEach(this.zones, (zone, index) => {
          let coords = map(zone.coords, (e) => {
            return [e[1], e[0]]
          })
          let polygon = new window.ymaps.Polygon([
            coords
          ], {
            hintContent: 'Бесплатная доставка от ' + this.numberLingFormWithNumber(zone.minSum, 'рубль', 'рубля', 'рублей')
          }, {
            fillColor: zone.color,
            strokeWidth: 5,
            opacity: this.defaultOpacity
          })
          this.map.geoObjects.add(polygon)
          if (!this.isSmartphone) {
            polygon.events.add('mouseenter', () => {
              this.$bus.$emit('set-delivery-zone-clients_front', index)
            })
            polygon.events.add('mouseleave', () => {
              this.$bus.$emit('set-delivery-zone-clients_front', null)
            })
          } else {
            polygon.events.add('click', () => {
              this.currentZoneIndex = index
            })
          }
          this.polygons.push(polygon)
          if (zone.fitMapByPolygon) {
            // this.map.setBounds(polygon.geometry.getBounds(), {
            //   checkZoomRange: true,
            //   preciseZoom: true,
            //   useMapMargin: true,
            //   zoomMargin: 0
            // })
          }
        })
      })

      this.$bus.$on('hover-delivery-zone-left-bar', (index) => {
        if (index === null) {
          forEach(this.polygons, (p) => {
            p.options.set('opacity', this.defaultOpacity)
          })
        } else {
          forEach(this.polygons, (p, i) => {
            if (i === index) {
              p.options.set('opacity', this.defaultOpacity)
            } else {
              p.options.set('opacity', 0)
            }
          })
        }
      })
    },
    beforeDestroy () {
      this.$bus.$off('hover-delivery-zone-left-bar')
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/index/Conditions.vue